/*
 * [y] hybris Platform
 *
 * Copyright (c) 2017 SAP SE or an SAP affiliate company.  All rights reserved.
 *
 * This software is the confidential and proprietary information of SAP
 * ("Confidential Information"). You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms of the
 * license agreement you entered into with SAP.
 */

$(function () {

    // ------------------------------ related offers -----------------------------------------
    $(document)
        .on('input', '.offer-qty', function () {
            let _this = $(this),
                value = parseInt(_this.val()),
                minOrderQty = parseInt(_this.attr('data-min-order-quantity')),
                stockLevel= parseInt(_this.attr('data-stock-level')),
                productStatus = _this.attr('data-product-status'),
                offer = _this.attr('data-offer-id'),
                defaultPrice = _this.attr('data-default-price');

            //init ui state
            (value > 9999) ? _this.val(9999) : _this.val(value);
            _this.closest('.table_list')
                .find('.btn').removeClass('tooltip disabled').removeAttr('disabled').end()
                .find('.min_order_quantity, .stock_error').addClass('hidden');

            $.ajax({
                url: ACC.config.updateMkpOfferItem,
                type: 'GET',
                data: {'offerCode': offer, 'defaultPrice': defaultPrice,'requestedQuantity': isNaN(value) === false ? value :1 },
                beforeSend: function() {
                    _this.closest('.table_list').find('.productPrices-loader').show();
                },
                success: function (data) {
                    _this.closest('.table_list')
                        .find('.price').text(data.price.formattedValue)
                        .find('.btn').removeAttr('disabled').end()
                        .find('.min_order_quantity, .stock_error').addClass('hidden');
                },
                complete: function(data) {
                    if(productStatus == 'outOfStock') { console.log('-1');
                        _this.closest('.table_list').find('input').attr('disabled', 'disabled');
                    } else {
                        if(isNaN(value)) { console.log('0');
                            _this.closest('.table_list')
                                .find('.btn').addClass('tooltip disabled').attr('disabled', true);
                        } else if(value < minOrderQty) { console.log('1');
                            _this.closest('.table_list')
                                .find('.error_msg__block')
                                .removeClass('hidden')
                                .find('.min_order_quantity')
                                .find('.minOrderQuantity').text(minOrderQty).end()
                                .removeClass('hidden').end()
                                .find('.error_msg__block .stock_error').addClass('hidden');
                            _this.closest('.table_list')
                                .find('.btn').addClass('tooltip disabled').attr('disabled', true);
                        } else if(value > stockLevel){ console.log('2');
                            _this.closest('.table_list')
                                .find('.error_msg__block .stock_error')
                                .find('.stockLevel').text(stockLevel).end()
                                .removeClass('hidden').end()
                                .find('.error_msg__block .min_order_quantity').addClass('hidden').end()
                                .find('.btn').addClass('tooltip disabled').attr('disabled', 'disabled');
                        }
                    }
                    _this.closest('.table_list').find('.productPrices-loader').hide();
                }
            });


        })
        .on('click', '.related-offers .table_list .btn', function () {
            let _this = $(this),
                parent = _this.closest('.table_list'),
                qtySelector = parent.find('.offer-qty'),
                offerId = qtySelector.attr('data-offer-id'),
                certificateCode = qtySelector.attr('data-mkp-certificate-code'),
                withMkpCertif = qtySelector.attr('data-with-mkp-certificate'),
                qty = parseInt(qtySelector.val());

            if(offerId !== undefined && qty !== undefined){
                $.ajax({
                    url: ACC.config.addMkpItem,
                    type: 'GET',
                    data: {'offerId': offerId, 'quantity': qty, 'withMkpCertificate':withMkpCertif, 'mkpCertificateCode':certificateCode},
                    success: function (data) {
                        ACC.product.displayAddToCartPopup(data);
                        if("" !== data.izbergApiErrorMessage) {
                            _this.attr('disabled', 'disabled');
                        }
                    },
                    error: function (xht, textStatus, ex) {
                        console.log(textStatus);
                    }
                });
            }else {
                console.error("Error sending request due to offerId : " + offerId + " or quantity : " + qty);
            }
        })
        .on('change', '.checkMkpCertif_buyBox_offer', function () {
            var checkbox = $(this);
            var input = checkbox.closest('.js-mkp-checkCertif_product').closest('li').siblings('#mkp-offer-qty').children('input');
            var isChecked = checkbox.is(':checked');

            if (isChecked) {
                input.attr('data-with-mkp-certificate', 'true');
            } else {
                input.attr('data-with-mkp-certificate', 'false');
            }
        });
    //--------------------------------------------------------------------------------------------------------------

    // Review Module
    $vendorReviewPopin = $("#vendorReviewPopin");

    $('.review-form-loader').on('click', function (e) {
        $vendorReviewPopin.modal({backdrop: 'static', keyboard: true});
    })

    $(document)
        .on('click', '.addReview', function (e) {
            e.preventDefault();
            var _this = $(this),
                userName = _this.data('user-name'),
                vendorName = _this.data('vendor-name'),
                vendorCode = _this.data('vendor-code'),
                vendorValue = _this.data('vendor-value');
            $('.review-form #userName').text(userName);
            $('.review-form #vendorName').text(vendorName);
            $('.review-form #merchantID').val(vendorCode);
            $('.review-form #merchantValue').val(vendorValue);
            // reset values
            let $reviewForm = $('#review-form');
            $reviewForm.find('#description').val('')
            $reviewForm.find('#title').val('')
            $('.js-writeReviewStars .js-ratingIcon').removeClass('active');
            //dispaly popin
            $('.errorMsg').hide()
            $vendorReviewPopin.modal();
        });
    // end popin review


    $(document).on('click', '.review-btn', function () {
        let $this = $(this),
            $reviewForm = $('#review-form'),
            title = $reviewForm.find('#title'),
            description = $reviewForm.find('#description'),
            score = $reviewForm.find('#rating-cmp-input'),
            merchantID = $reviewForm.find('#merchantID'),
            merchantValue = $reviewForm.find('#merchantValue');

        $.ajax({
            url: $this.data('action'),
            type: 'POST',
            data: {
                score: score.val(),
                title: title.val(),
                description: description.val(),
                merchant: merchantID.val(),
                merchant_order: merchantValue.val()
            },
            success: function (response) {
                console.log(response.message !== null)

                if (response.status === 'success') {
                    $("#vendorReviewPopin").find(title).val('').end().find(description).val('');
                    $('.vendor-'+ merchantID.val() ).remove();
                    location.reload();
                } else {
                    $('.errorMsg').hide()
                    if(response.message !== null) {
                        $("#vendorReviewPopin .popin_container .errorMsg").html(response.message).show();
                    } else {
                        handleErrors(response.fieldsError);
                    }
                }
            }
        });

        function handleErrors(fieldsError) {
            $('.errorMsg').hide()
            $("#vendorReviewPopin").find('input, textarea').removeClass('error')
            if (Object.values(fieldsError).length > 0) {
                Object.keys(fieldsError[0]).forEach(key => {
                    getErrorMessag(key);
                });
            }

            function getErrorMessag(key) {
                switch (key) {
                    case 'score':
                        $("#vendorReviewPopin #rating-cmp-input").parent('div').find('.errorMsg').html(scoreErrorMsg).show();
                        break;
                    case 'title':
                        $("#vendorReviewPopin #title").addClass('error').parent('div').find('.errorMsg').html(titleErrorMsg).show();
                        break;
                    case 'description':
                        $("#vendorReviewPopin #description").addClass('error').parent('div').find('.errorMsg').html(descriptionErrorMsg).show();
                        break;
                }
            }
        }

    })



    //Rating
    $(".rating-cmp").starRating({
        totalStars: 5,
        activeColor: 'gold',
        ratedColor: 'crimson',
        strokeWidth: 0,
        starSize: 25,
        useGradient: false,
        useFullStars: true,
        minRating: 1,
        starShape: 'rounded',
        disableAfterRate: false,
        callback: function (currentRating, $el) {
            $('#rating-cmp-input').val(currentRating);
            $('#rating-cmp-input').parent().find('.errorMsg').hide()
        },
        onHover: function (currentIndex, currentRating, $el) {
            $('#rating-cmp-input').val(currentRating)
        },
        onLeave: function (currentIndex, currentRating, $el) {
            $('#rating-cmp-input').val(currentRating)
        }
    });

    $(".rating-cmp-read").starRating({
        readOnly: true,
        strokeWidth: 0, starSize: 25
    });

    /* initiate plugin */
    $("div.holder").jPages({
        containerID: "reviews",
        perPage: 4,
        first: "",
        previous: "←",
        next: "→",
        last: ""
    });


    //SP3
    //address list popin
    $(document).on('click', '.addAddress', function () {
        $('#popinListAddressForm').modal('hide');
        $('#popinAddAddressForm').modal({backdrop: 'static', keyboard: true});
    });

    var isMKPEnabled = ACC.config.isMKPEnabled,
        isAnonymousUser = ACC.config.isAnonymousUser;
    if(isMKPEnabled ==='true' && isAnonymousUser !=='true') {
        (async () => {
            var shippingAddressInfo = await fetch(ACC.config.shippingAddressInfoUrl),
                shippingAddressInfoList = await shippingAddressInfo.json();
            if(shippingAddressInfoList.showSelectionPopin) {
                var addressListBlock = $('.addressListBlock'), result = '';
                shippingAddressInfoList.listAddressData.forEach((address, index) => {
                    result += `<li class="amds-radiobox">
                          
                            <div class="radioWrapper">
                            <label for="address_${address.id}">
                              <div class="d-flex"><input type="radio" data-postal-code="${address.postalCode}"
                                name="selectedAddress" id="address_${address.id}"
                                value="${address.id}">
                                <span class="custom-radio mr-20"></span>
                                </div>
                                   <div> <b>`;
                    if(null != address.line1 && null != address.line2) {
                        result += `${address.line1}&nbsp; ${address.line2}`;
                    }else if(null != address.line1 && null == address.line2 ){
                        result += `${address.line1}`;
                    }else if(null != address.line2 && null == address.line1){
                        result += `${address.line2}`;
                    }
                    result += `</b><br/>`;
                    result += `</b> ${address.town}<br/>`;
                    if(null != address.country && null != address.country.name) {
                        result += `${address.country.name}`;
                    }
                    result += ` ${address.postalCode}
                                </div>
                        </label>`;
                    if(shippingAddressInfoList.customerType == 'B2BCustomerVdc') {
                        result += ` <div class="associated-agency hidden">
                                        <h5>${chooseAssociatedAgency}</h5>
                                        <ul>`;
                        if(null != address.agencies) {
                            var agencies ='', cssClass ='',
                                agenciesSize = address.agencies.length === 1;

                            address.agencies.forEach((agency, index) => {
                                (index % 2 === 0 && !agenciesSize) ? cssClass =' prime': cssClass ='';
                                result += ` <li class="${cssClass}">
                                                <input type="hidden" name="agency" value="${agency.name}">
                                                <b>${agency.displayName}</b><br/>
                                                ${agency.address.line2}<br/>
                                                ${agency.address.postalCode} ${agency.address.town}
                                                <img src="/_ui/responsive/theme-amds/images/myaccount-icons/checked_gray.png"  class="gray"/>
                                                <img src="/_ui/responsive/theme-amds/images/myaccount-icons/checked_red.png" class="red"/>    
                                            </li>`;
                            });
                        }
                        result += `</ul></div>`;
                    }
                    result += `</div></li>`;
                    addressListBlock.html(result);
                });
                $('#popinListAddressForm').modal({backdrop: 'static', keyboard: true});
            } else if(shippingAddressInfoList.showCreationPopin) {
                $('#popinAddAddressForm').modal({backdrop: 'static', keyboard: true});
                $('#popinStoreFinder').modal('hide');
            }
        })();
    }



    // on click address
    $('.addressListBlock').on('click', 'label', function () {
        //when one element
        var elementsSize = $(this).parents('li').find('.associated-agency li').size();
        if(elementsSize > 1 ) {
            $('.associated-agency').find('li').removeClass('active').end().addClass('hidden');
            $('input[name=selectedAgency]').val();
            $('.btn-action, .js-btn-action').attr('disabled', true);
        } else {
            $(this).closest('li').find('.associated-agency li').addClass('active');
            $('input[name=selectedAgency]').val($(this).closest('li').find('input[name=agency]').val());
            $('.associated-agency').addClass('hidden');
            $('.btn-action, .js-btn-action').removeAttr('disabled');
        }
        $(this).parents('li').find('.associated-agency').removeClass('hidden');
    });

    $(document).on('click', '.associated-agency li', function () {
        //reset
        $('li').removeClass('active');
        $('input[name=selectedAgency]').val('');
        //fill
        $(this).addClass('active');
        $('input[name=selectedAgency]').val($(this).find('input[name=agency]').val());
        if(!$(this).parent('ul').hasClass('choose-agency_list')){
            $('.btn-action, .js-btn-action').removeAttr('disabled');
        }
    });

    let isSubmitting = false;

    $(document).off('submit', '#addAddressForm').on('submit', '#addAddressForm', function (event) {
        event.preventDefault();

        if (isSubmitting) return; // 🛑 Prevent multiple submissions
        isSubmitting = true;

        $('.btn-action, .js-btn-action').prop('disabled', true);

        let currentForm = $(this);
        $('.amds-form-field__errormsg span').addClass('display-none');
        const hasErrors = handleErrors(currentForm);

        if (hasErrors) {
            isSubmitting = false; // ✅ Reset flag
            $('.btn-action, .js-btn-action').prop('disabled', false);
            return;
        }

        const data = {
            'titleCode': currentForm.find('#titleCode').val(),
            'firstName': currentForm.find('#firstName').val(),
            'lastName': currentForm.find('#lastName').val(),
            'line1': currentForm.find('#line1').val(),
            'townCity': currentForm.find('#townCity').val(),
            'postCode': currentForm.find('#postcode').val(),
            'countryIso': currentForm.find('#countryIso').val(),
            'isDefaultAddress': currentForm.find('#defaultAddress').val(),
            'pointOfService': currentForm.find('input[name=selectedAgency]').val(),
        };

        $.ajax({
            url: ACC.config.addDefaultaddressUrl,
            type: 'post',
            data: data,
            success: function (response) {
                if (response.status === 'error') {
                    handleErrorsMessages(currentForm, response.fieldsError);
                    isSubmitting = false; // ✅ Allow retry
                    $('.btn-action, .js-btn-action').prop('disabled', false);
                } else {
                    displayMsg(response.message);
                    setTimeout(() => location.reload(), 2000);
                }
            },
            error: function () {
                isSubmitting = false;
                $('.btn-action, .js-btn-action').prop('disabled', false);
            }
        });

        function displayMsg(message) {
            $('.response-message').html(message);
        }

        function handleErrors(form) {
            let errorFound = false;
            form.find('input[type=text]').each(function () {
                if ($(this).val().trim().length === 0) {
                    $(this).parent().find('.amds-form-field__errormsg span').removeClass('display-none');
                    errorFound = true;
                }
            });
            return errorFound;
        }

        function handleErrorsMessages(form, fieldsErrors) {
            fieldsErrors.forEach(errorObj => {
                Object.keys(errorObj).forEach(fieldName => {
                    const input = $('#'+fieldName);

                    if (input.length > 0) {
                        const fieldContainer = input.closest('.amds-form-field');
                        if(fieldName === 'postcode'){
                            const errorSpan = fieldContainer.find('.invalidZipcodeMsg');
                            errorSpan.removeClass('display-none').text(invalidZipcode);
                        }else{
                            const errorSpan = fieldContainer.find('.amds-form-field__errormsg span');
                            errorSpan.removeClass('display-none');
                        }
                    }
                });
            });
        }
    })

    //disable btn when checkbox is false
        .on('click', '#defaultAddress', function () {
            //Check if inputs are empty
            let emptyFields = 0;
            $('#addAddressForm input.amds-form-field__input').each(function() {
                if ($(this).val() === "" || $(this).val() === "" || ($(this).val() !== "" && $(this).hasClass('hasError'))) {
                    emptyFields++;
                }
            });


            $(this).is(":checked") && !emptyFields ?  $('.btn-action').removeAttr('disabled') : $('.btn-action').attr('disabled', true);
        })
        .on('keyup', '#addAddressForm input.amds-form-field__input', function () {
            $(this).val().length !== 0 && $('#defaultAddress').is(":checked")
                ?  $('.btn-action').removeAttr('disabled')
                : $('.btn-action').attr('disabled', true);
        })
        .on('copy paste cut', '#addAddressForm input.amds-form-field__input', function (e) {
            e.preventDefault();

        })
        // post Code change $( "#myselect option:selected" ).text();
        .on('keyup input', '#addAddressForm #postcode', function () {
            $('.associated-agency').addClass('hidden');
            $('#addAddressForm #postcode')
                .closest('.amds-form-field')
                .find('.invalidZipcodeMsg')
                .addClass('display-none')
                .end()
                .find('.amds-form-field__input')
                .removeClass('hasError');
            $('#defaultAddress').prop('checked', false);

            var postcode = $(this).val(),
                countryIso = $(this).closest('#addAddressForm').find('#countryIso').val();
            if(postcode.length > 4) {
                $.ajax({
                    url: `${ACC.config.pointOfServicesUrl}/${countryIso}/${postcode}`,
                    success: function (data) {
                        if(data.results.length > 0) {
                            let result = ` <h5>${chooseAssociatedAgency}</h5>
                                <ul class='choose-agency_list'>`;
                            var agencies ='', cssClass ='',
                                agenciesSize = data.results.length === 1;
                            data.results.forEach((agency, index) => {
                                (index % 2 === 0 && !agenciesSize) ? cssClass =' prime': cssClass ='';
                                result += ` <li class="${cssClass}">
                                            <input type="hidden" name="agency" value="${agency.name}">
                                            <b>${agency.name}</b><br/>
                                            ${agency.address.line2}<br/>
                                            ${agency.address.postalCode} ${agency.address.town}
                                            <img src="/_ui/responsive/theme-amds/images/myaccount-icons/checked_gray.png"  class="gray"/>
                                            <img src="/_ui/responsive/theme-amds/images/myaccount-icons/checked_red.png" class="red"/>    
                                        </li>`;
                            });
                            result += `</ul>`;
                            $('.associated-agency').html(result).removeClass('hidden');
                            if(agenciesSize) {
                                $('.associated-agency li:visible').trigger('click');
                            } else {
                                $('input[name=selectedAgency]').val('');
                            }
                        } else {
                            $('#addAddressForm #postcode').closest('.amds-form-field')
                                .find('.amds-form-field__input').addClass('hasError').end()
                                .find('.invalidZipcodeMsg').removeClass('display-none')
                        }

                    }
                });
            }
        })
        .on('click', '#chooseAddress', function (event) {
            event.preventDefault();
            let selectedAddress = $('input[name=selectedAddress]:checked'),
                pointOfServiceName = $('input[name=selectedAgency]').val(),
                data = {'idOfselectedAddress': selectedAddress.val(), 'postCode': selectedAddress.attr('data-postal-code'),
                    'pointOfServiceName': pointOfServiceName, 'isChecked':  $('input[name=defaultAddress]').is(':checked')};
            $.ajax({
                url: ACC.config.setDefaultShippingAddressInfoUrl,
                type: 'post',
                data: data,
                success: function () {
                    location.reload();
                }
            });
        });





    // ----------------------------------------------------------------------------------------
    //FACET PDP
    $(document)
        .on("change", ".js-product-facet .js-facet-checkbox", function(event) {
            event.preventDefault();
            var valuesArray = $('.facet input:checked').map(function () {
                return this.value;
            }).get().join(":");
            $('.btn-filter').find('#q').val(valuesArray);
            if(!window.matchMedia("(max-width: 767px)").matches) {
                return $('.btn-filter').submit();
            }
        });
})
